"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const omit_1 = __importDefault(require("lodash/omit"));
/**
 * map initial state for as store to store state
 * @param {Object} store
 * @param {Object} initialState
 */
function mapInitialStateToStoreState(store, initialState) {
    const storeInitialState = (0, omit_1.default)(initialState, '$env');
    Object.keys(storeInitialState).forEach((key) => {
        store[key] = storeInitialState[key];
    });
}
exports.default = mapInitialStateToStoreState;
